import React from "react";
import { constantNoMesin } from "../../util/constant";
import { useOperator } from "./useOperator";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import Select from "react-select";
import "./Operator.css";

/* ====== Komponen kecil (sengaja di luar Operator agar input tidak kehilangan fokus) ====== */
const Field = ({ label, required, className = "", children }) => (
  <div className={`opr_field ${className}`}>
    <label className="opr_label">
      {label}
      {required ? <span className="opr_req">*</span> : ""}
    </label>
    {children}
  </div>
);

const Stat = ({ label, value, error, className = "" }) => (
  <div className={`opr_stat ${error ? "opr_stat_error" : ""} ${className}`}>
    <span className="opr_label">{label}</span>
    <span className="opr_stat_value">{value}</span>
  </div>
);

const NumInput = (props) => (
  <input
    type="number"
    className="opr_input"
    onWheel={(e) => e.target.blur()}
    {...props}
  />
);

const MesinOptions = () => (
  <>
    <option value="Pilih Mesin" disabled>
      Pilih Mesin
    </option>
    {constantNoMesin &&
      constantNoMesin.map((data) => (
        <option key={data} value={data}>
          {data}
        </option>
      ))}
  </>
);

const ShiftOptions = () => (
  <>
    <option value="Pilih Shift" disabled>
      Pilih Shift
    </option>
    <option value="1">Shift 1</option>
    <option value="2">Shift 2</option>
    <option value="3">Shift 3</option>
  </>
);

const MesinTanggalShift = ({
  mesin,
  onMesin,
  date,
  onDate,
  shift,
  onShift,
}) => (
  <div className="opr_card">
    <div className="opr_row opr_row_3">
      <Field label="Pilih Mesin" required>
        <select
          className="opr_select"
          value={mesin}
          onChange={(e) => onMesin(e.target.value)}
        >
          <MesinOptions />
        </select>
      </Field>
      <Field label="Pilih Tanggal" required>
        <input
          type="date"
          className="opr_input"
          value={date}
          onChange={(e) => onDate(e.target.value)}
        />
      </Field>
      <Field label="Pilih Shift" required>
        <select
          className="opr_select"
          value={shift}
          onChange={(e) => onShift(e.target.value)}
        >
          <ShiftOptions />
        </select>
      </Field>
    </div>
  </div>
);

const StepButtons = ({ onRemove, onAdd }) => (
  <div className="opr_stepper">
    <button className="button_plus" onClick={onRemove}>
      &#8722;
    </button>
    <button className="button_plus" onClick={onAdd}>
      &#43;
    </button>
  </div>
);

const ErrorBanner = () => (
  <p className="opr_error">Mohon Periksa Kolom yang Wajib Diisi!</p>
);

const Operator = () => {
  const {
    dataUser,
    handleRejectDesc,
    dataReject,
    addFields,
    removeFields,
    shiftOperator,
    setShiftOperator,
    setMesinOperator,
    setDateOperator,
    handleKirim,
    setIsiPerKemasan,
    setAktualCavity,
    setCounterAkhir,
    setCounterAwal,
    setJumlahBarang,
    setKeterangan,
    mesinOperator,
    isiPerKemasan,
    aktualCavity,
    counterAkhir,
    counterAwal,
    jumlahNG,
    jumlahBarang,
    keterangan,
    isError,
    popUpKirim,
    setDowntime,
    downtime,
    setPopUpKirim,
    subMenuOperator,
    setSubMenuOperator,
    dateOperator,
    isToco,
    setIsToco,
    sisaShiftSebelumnya,
    setSisaShiftSebelumnya,
    produkVP,
    setProdukVP,
    shiftPasangKaret,
    setShiftPasangKaret,
    mesinPasangKaret,
    setMesinPasangKaret,
    keteranganPasangKaret,
    setKeteranganPasangKaret,
    handleKirimPasangKaret,
    jumlahPasangKaret,
    setJumlahPasangKaret,
    isErrorPasangKaret,
    setDowntimePasangKaret,
    downtimePasangKaret,
    kepalaShift,
    setKepalaShift,
    warnaVP,
    setWarnaVP,
    aktualCavityPasangKaret,
    setAktualCavityPasangKaret,
    setCustomerVentPlug,
    customerVentPlug,
    listReject,
    aktualBarang,
    setAktualBarang,
    dataListMold,
    listProduk,
    pasangStikerSelect,
    setPasangStikerSelect,
    handleKirimPasangStiker,
    dataListPR,
    errorPasangSticker,
    handleKirimPasangTopPlate,
    dataKeterangan,
    handleKeterangan,
    ngSticker,
    setNgSticker,
    addFieldsKeterangan,
    removeFieldsKeterangan,
    rejectProduk,
    setRejectProduk,
    addFieldsSticker,
    removeFieldsSticker,
    dataRejectSticker,
    handleRejectSticker,
  } = useOperator();

  const checkCounterAkhir = counterAkhir ? counterAkhir : 0;
  const checkCounterAwal = counterAwal ? counterAwal : 0;

  const sumReject =
    dataReject &&
    dataReject.reduce(function (s, a) {
      return s + a.totalNG;
    }, 0);

  const subMenuClass = (name) =>
    subMenuOperator === name
      ? "sub_menu_history border_active_history"
      : "sub_menu_history";

  const KepalaShiftOptions = () => (
    <>
      <option value="Pilih Kepala Shift" disabled>
        Pilih Kepala Shift
      </option>
      {dataUser.tim === 2 ? (
        <>
          <option value={"FINDRI"}>FINDRI</option>
          <option value={"EKO"}>EKO</option>
          <option value={"IMAM PRACOYO"}>IMAM PRACOYO</option>
        </>
      ) : (
        <>
          <option value={"ACHMAD"}>ACHMAD</option>
          <option value={"SARIPUDIN"}>SARIPUDIN</option>
          <option value={"SUPRIADI"}>SUPRIADI</option>
        </>
      )}
    </>
  );

  return (
    <div className="container_inventory opr_page">
      {popUpKirim ? (
        <PopUpComponent>
          <p>Data Kamu Berhasil dikrim!</p>
          <div className="wrapper_button_submit_popup">
            <button
              className="button_popup"
              onClick={() => setPopUpKirim(false)}
            >
              OK
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}

      <p className="title_inventory">Laporan Produksi</p>
      <div className="wrapper_sub_menu_history">
        <p
          className={subMenuClass("laporanProduksi")}
          onClick={() => setSubMenuOperator("laporanProduksi")}
        >
          Produksi
        </p>
        {dataUser.tim === 1 ? (
          <>
            <p
              className={subMenuClass("laporanPasangKaret")}
              onClick={() => setSubMenuOperator("laporanPasangKaret")}
            >
              Pasang Karet
            </p>
            <p
              className={subMenuClass("laporanTopPlate")}
              onClick={() => setSubMenuOperator("laporanTopPlate")}
            >
              Top Plate
            </p>
          </>
        ) : (
          ""
        )}
        <p
          className={subMenuClass("laporanPasangStiker")}
          onClick={() => setSubMenuOperator("laporanPasangStiker")}
        >
          Pasang Sticker
        </p>
      </div>

      {isError ? <ErrorBanner /> : ""}

      {/* ================= PRODUKSI ================= */}
      {subMenuOperator === "laporanProduksi" ? (
        <>
          <MesinTanggalShift
            mesin={mesinOperator}
            onMesin={setMesinOperator}
            date={dateOperator}
            onDate={setDateOperator}
            shift={shiftOperator}
            onShift={setShiftOperator}
          />

          <div className="opr_card">
            <p className="opr_card_title">Data Produksi</p>
            <div className="opr_row opr_row_2">
              <Field label="Isi Per Kemasan" required>
                <NumInput
                  placeholder="Isi Per Kemasan"
                  value={isiPerKemasan}
                  onChange={(e) =>
                    setIsiPerKemasan(e.target.value.split(".").join(""))
                  }
                />
              </Field>
              <Field label="Aktual Cavity" required>
                <NumInput
                  placeholder="Aktual Cavity"
                  value={aktualCavity}
                  onChange={(e) => setAktualCavity(e.target.value)}
                />
              </Field>

              <Field label="Counter Akhir" required>
                <NumInput
                  placeholder="Counter Akhir"
                  value={counterAkhir}
                  onChange={(e) =>
                    setCounterAkhir(e.target.value.split(".").join(""))
                  }
                />
              </Field>
              <Field label="Counter Awal" required>
                <NumInput
                  placeholder="Counter Awal"
                  value={counterAwal}
                  onChange={(e) =>
                    setCounterAwal(e.target.value.split(".").join(""))
                  }
                />
              </Field>

              <Stat
                label="Selisih Counter"
                value={checkCounterAkhir - checkCounterAwal}
              />
              <Field
                label={
                  dataUser.tim === 2
                    ? "Sisa Shift Sebelumnya"
                    : `Receh Shift ${shiftOperator}`
                }
                required
              >
                <NumInput
                  placeholder={
                    dataUser.tim === 2 ? "Sisa Shift Sebelumnya" : "Receh Shift"
                  }
                  value={sisaShiftSebelumnya}
                  onChange={(e) =>
                    setSisaShiftSebelumnya(e.target.value.split(".").join(""))
                  }
                />
              </Field>

              <Stat
                label={'Jumlah "NG"'}
                value={jumlahNG ? jumlahNG : 0}
                error={sumReject !== Number(jumlahNG)}
              />
              <Field label="Produk OK (Pcs)" required>
                <NumInput
                  placeholder="Produk OK"
                  value={jumlahBarang}
                  onChange={(e) =>
                    setJumlahBarang(e.target.value.split(".").join(""))
                  }
                />
              </Field>

              <Field label="Downtime (Menit)" required>
                <NumInput
                  placeholder="Downtime"
                  value={downtime}
                  onChange={(e) => setDowntime(e.target.value)}
                />
              </Field>
              {dataUser.tim === 1 ? (
                <Field label="Top Cover GTZ5S (#13/#15)">
                  <label className="opr_check">
                    <input
                      type="checkbox"
                      checked={isToco}
                      onChange={() => setIsToco(!isToco)}
                    />
                    TOP COVER
                  </label>
                </Field>
              ) : (
                <Stat
                  label="Produk OK + SISA"
                  value={
                    Number(jumlahBarang) + Number(sisaShiftSebelumnya)
                      ? Number(jumlahBarang) + Number(sisaShiftSebelumnya)
                      : 0
                  }
                />
              )}

              {dataUser.tim === 2 ? (
                <Stat
                  label="Selisih Barang"
                  value={
                    Number(aktualBarang) -
                    Number(jumlahBarang) -
                    Number(sisaShiftSebelumnya)
                      ? Number(aktualBarang) -
                        Number(jumlahBarang) -
                        Number(sisaShiftSebelumnya)
                      : 0
                  }
                />
              ) : (
                ""
              )}
              <Field label="Aktual Barang" required>
                <NumInput
                  placeholder="Aktual Barang"
                  value={aktualBarang}
                  onChange={(e) =>
                    setAktualBarang(e.target.value.split(".").join(""))
                  }
                />
              </Field>
            </div>
          </div>

          <div className="opr_card">
            <p className="opr_card_title">Perincian "NG"</p>
            <div className="opr_list_head opr_cols_ng">
              <span>Alasan</span>
              <span>Jumlah</span>
            </div>
            {dataReject &&
              dataReject.map((data, index) => (
                <div className="opr_list_row opr_cols_ng" key={index}>
                  <div className="select_item_gbj">
                    <Select
                      placeholder={data.id}
                      value={data.id}
                      options={listReject}
                      onChange={(e) =>
                        handleRejectDesc(index, e, "kindOfReject")
                      }
                    />
                  </div>
                  <NumInput
                    placeholder="Jumlah"
                    name="totalNG"
                    value={Number(data.totalNG) ? Number(data.totalNG) : ""}
                    onChange={(e) => handleRejectDesc(index, e)}
                  />
                </div>
              ))}
            <StepButtons onRemove={removeFields} onAdd={addFields} />
          </div>

          <div className="opr_card">
            <p className="opr_card_title">Keterangan</p>
            {dataUser.tim === 1 ? (
              <>
                <div className="opr_list_head opr_cols_jam">
                  <span>Jam</span>
                  <span>Keterangan</span>
                </div>
                {dataKeterangan &&
                  dataKeterangan.map((data, index) => (
                    <div className="opr_list_row opr_cols_jam" key={index}>
                      <input
                        className="opr_input opr_input_jam"
                        placeholder="08.00-09.00"
                        type="text"
                        inputMode="numeric"
                        maxLength={11}
                        name="jam"
                        value={data.jam ? data.jam : ""}
                        onChange={(e) => handleKeterangan(index, e)}
                      />
                      <input
                        className="opr_input"
                        placeholder="Keterangan"
                        type="text"
                        name="keterangan"
                        value={data.keterangan ? data.keterangan : ""}
                        onChange={(e) => handleKeterangan(index, e)}
                      />
                    </div>
                  ))}
                <StepButtons
                  onRemove={removeFieldsKeterangan}
                  onAdd={addFieldsKeterangan}
                />
              </>
            ) : (
              <textarea
                className="opr_textarea"
                value={keterangan}
                onChange={(e) => setKeterangan(e.target.value)}
              />
            )}
          </div>

          <div className="opr_actions">
            <button
              className="button_submit_memo"
              onClick={() => handleKirim()}
            >
              Kirim
            </button>
          </div>
        </>
      ) : subMenuOperator === "laporanPasangKaret" ? (
        /* ================= PASANG KARET ================= */
        <>
          {isErrorPasangKaret ? <ErrorBanner /> : ""}

          <MesinTanggalShift
            mesin={mesinPasangKaret}
            onMesin={setMesinPasangKaret}
            date={dateOperator}
            onDate={setDateOperator}
            shift={shiftPasangKaret}
            onShift={setShiftPasangKaret}
          />

          <div className="opr_card">
            <p className="opr_card_title">Data Pasang Karet</p>
            <div className="opr_row opr_row_2">
              <Field label="Pilih Produk" required className="opr_span_2">
                <select
                  className="opr_select"
                  value={produkVP}
                  onChange={(e) => setProdukVP(e.target.value)}
                >
                  <option value="Pilih Produk">Pilih Produk</option>
                  <option value="VENT PLUG G18-A50 NEM (1)">
                    VENT PLUG G18-A50 NEM (1)
                  </option>
                  <option value="VENT PLUG G18-A50 NEM (2)">
                    VENT PLUG G18-A50 NEM (2)
                  </option>
                  <option value="VENT PLUG G18-A50 NL (1)">
                    VENT PLUG G18-A50 NL (1)
                  </option>
                  <option value="VENT PLUG G18-A50 NL (3)">
                    VENT PLUG G18-A50 NL (3)
                  </option>
                  <option value="VENT PLUG G18-A50 NL (4)">
                    VENT PLUG G18-A50 NL (4)
                  </option>
                  <option value="VENT PLUG G18-A50 NL (5)">
                    VENT PLUG G18-A50 NL (5)
                  </option>
                  <option value="VENT PLUG G30-A9 NEM">
                    VENT PLUG G30-A9 NEM
                  </option>
                  <option value="VENT PLUG G30-A9 NL">
                    VENT PLUG G30-A9 NL
                  </option>
                  <option value="VENT PLUG F20-2K (1)">
                    VENT PLUG F20-2K (1)
                  </option>
                  <option value="VENT PLUG F20-2K (2)">
                    VENT PLUG F20-2K (2)
                  </option>
                  <option value="VENT PLUG F20-2K (4)">
                    VENT PLUG F20-2K (4)
                  </option>
                  <option value="VENT PLUG F20-2K (5)">
                    VENT PLUG F20-2K (5)
                  </option>
                </select>
              </Field>

              <Field label="Pilih Warna" required>
                <select
                  className="opr_select"
                  value={warnaVP}
                  onChange={(e) => setWarnaVP(e.target.value)}
                >
                  <option value="Pilih Warna">Pilih Warna</option>
                  <option value="HTM">HITAM</option>
                  <option value="KNG">KUNING</option>
                  <option value="ORG">ORANGE</option>
                </select>
              </Field>
              <Field label="Customer" required>
                <select
                  className="opr_select"
                  value={customerVentPlug}
                  onChange={(e) => setCustomerVentPlug(e.target.value)}
                >
                  <option value="Pilih Customer">Pilih Customer</option>
                  <option value="GS">GS</option>
                  <option value="CBI">CBI</option>
                  <option value="YBI">YBI</option>
                </select>
              </Field>

              <Field label="Kepala Shift" required>
                <select
                  className="opr_select"
                  value={kepalaShift}
                  onChange={(e) => setKepalaShift(e.target.value)}
                >
                  <option value="Pilih Kepala Shift" disabled>
                    Pilih Kepala Shift
                  </option>
                  <option value={"SUPRIADI"}>SUPRIADI</option>
                  <option value={"ACHMAD SANIN"}>ACHMAD SANIN</option>
                  <option value={"SARIPUDIN"}>SARIPUDIN</option>
                </select>
              </Field>
              <Field label="Aktual Cavity" required>
                <NumInput
                  placeholder="Aktual Cavity"
                  value={aktualCavityPasangKaret}
                  onChange={(e) =>
                    setAktualCavityPasangKaret(
                      e.target.value.split(".").join("")
                    )
                  }
                />
              </Field>

              <Field label="Jumlah Pasang Karet (Pcs)" required>
                <NumInput
                  placeholder="Jumlah Pasang Karet (Pcs)"
                  value={jumlahPasangKaret}
                  onChange={(e) =>
                    setJumlahPasangKaret(e.target.value.split(".").join(""))
                  }
                />
              </Field>
              <Field label="Downtime (Menit)">
                <NumInput
                  placeholder="Downtime"
                  value={downtimePasangKaret}
                  onChange={(e) =>
                    setDowntimePasangKaret(e.target.value.split(".").join(""))
                  }
                />
              </Field>
            </div>
          </div>

          <div className="opr_card">
            <p className="opr_card_title">Keterangan Pasang Karet</p>
            <textarea
              className="opr_textarea"
              value={keteranganPasangKaret}
              onChange={(e) => setKeteranganPasangKaret(e.target.value)}
            />
          </div>

          <div className="opr_actions">
            <button
              className="button_submit_memo"
              onClick={() => handleKirimPasangKaret()}
            >
              Kirim
            </button>
          </div>
        </>
      ) : subMenuOperator === "laporanPasangStiker" ? (
        /* ================= PASANG STICKER ================= */
        <>
          {errorPasangSticker ? <ErrorBanner /> : ""}

          <MesinTanggalShift
            mesin={mesinOperator}
            onMesin={setMesinOperator}
            date={dateOperator}
            onDate={setDateOperator}
            shift={shiftOperator}
            onShift={setShiftOperator}
          />

          <div className="opr_card">
            <p className="opr_card_title">Data Pasang Sticker</p>
            <div className="opr_row opr_row_2">
              <Field label="Kepala Shift" required>
                <select
                  className="opr_select"
                  value={kepalaShift}
                  onChange={(e) => setKepalaShift(e.target.value)}
                >
                  <KepalaShiftOptions />
                </select>
              </Field>
              <Field label="Customer" required>
                <select
                  className="opr_select"
                  value={customerVentPlug}
                  onChange={(e) => setCustomerVentPlug(e.target.value)}
                >
                  <option value="Pilih Customer">Pilih Customer</option>
                  {dataUser.tim === 2 ? (
                    <>
                      {dataListMold &&
                        dataListMold.map((ele) => (
                          <option key={ele.company} value={ele.company}>
                            {ele.company}
                          </option>
                        ))}
                    </>
                  ) : (
                    <>
                      {dataListPR &&
                        dataListPR.map((ele) => (
                          <option key={ele.customer} value={ele.customer}>
                            {ele.customer}
                          </option>
                        ))}
                    </>
                  )}
                </select>
              </Field>

              <Field label="Pilih Produk" required className="opr_span_2">
                <Select
                  placeholder={pasangStikerSelect || "Pilih Produk"}
                  value={pasangStikerSelect || ""}
                  options={listProduk}
                  onChange={(e) => setPasangStikerSelect(e)}
                />
              </Field>

              <Field label="Jumlah (Pcs)" required>
                <NumInput
                  placeholder="Jumlah (Pcs)"
                  value={jumlahPasangKaret}
                  onChange={(e) =>
                    setJumlahPasangKaret(e.target.value.split(".").join(""))
                  }
                />
              </Field>
              <Field label="NG Sticker" required>
                <NumInput
                  placeholder="NG (Pcs)"
                  value={ngSticker || ""}
                  onChange={(e) =>
                    setNgSticker(e.target.value.split(".").join(""))
                  }
                />
              </Field>
              <Field label="NG Produk" required>
                <NumInput
                  placeholder="NG (Pcs)"
                  value={rejectProduk || ""}
                  onChange={(e) =>
                    setRejectProduk(e.target.value.split(".").join(""))
                  }
                />
              </Field>
              <Field label="Downtime (Menit)">
                <NumInput
                  placeholder="Downtime"
                  value={downtimePasangKaret}
                  onChange={(e) =>
                    setDowntimePasangKaret(e.target.value.split(".").join(""))
                  }
                />
              </Field>
            </div>
          </div>

          {dataUser.tim === 1 ? (
            <div className="opr_card">
              <p className="opr_card_title">Ket. Reject Produk</p>
              <div className="opr_list_head opr_cols_sticker">
                <span>Shift</span>
                <span>Perincian "NG"</span>
                <span>Jumlah</span>
              </div>
              {dataRejectSticker &&
                dataRejectSticker.map((data, index) => (
                  <div className="opr_list_row opr_cols_sticker" key={index}>
                    <select
                      onChange={(e) => handleRejectSticker(index, e, "shift")}
                      className="opr_select"
                      name="shift"
                      value={data?.shift || "Pilih Shift"}
                    >
                      <option value="Pilih Shift" disabled>
                        Pilih Shift
                      </option>
                      <option value="SUPRIADI">SUPRIADI</option>
                      <option value="SARIPUDIN">SARIPUDIN</option>
                      <option value="ACHMAD">ACHMAD</option>
                    </select>
                    <div className="select_item_gbj">
                      <Select
                        placeholder={data.id}
                        value={data.id}
                        options={listReject}
                        onChange={(e) =>
                          handleRejectSticker(index, e, "kindOfReject")
                        }
                      />
                    </div>
                    <NumInput
                      placeholder="Jumlah"
                      name="totalNG"
                      value={Number(data.totalNG) ? Number(data.totalNG) : ""}
                      onChange={(e) => handleRejectSticker(index, e)}
                    />
                  </div>
                ))}
              <StepButtons
                onRemove={removeFieldsSticker}
                onAdd={addFieldsSticker}
              />
            </div>
          ) : (
            ""
          )}

          <div className="opr_card">
            <p className="opr_card_title">Keterangan Pasang Sticker</p>
            <textarea
              className="opr_textarea"
              value={keteranganPasangKaret}
              onChange={(e) => setKeteranganPasangKaret(e.target.value)}
            />
          </div>

          <div className="opr_actions">
            <button
              className="button_submit_memo"
              onClick={() => handleKirimPasangStiker()}
            >
              Kirim
            </button>
          </div>
        </>
      ) : subMenuOperator === "laporanTopPlate" ? (
        /* ================= TOP PLATE ================= */
        <>
          {errorPasangSticker ? <ErrorBanner /> : ""}

          <MesinTanggalShift
            mesin={mesinOperator}
            onMesin={setMesinOperator}
            date={dateOperator}
            onDate={setDateOperator}
            shift={shiftOperator}
            onShift={setShiftOperator}
          />

          <div className="opr_card">
            <p className="opr_card_title">Data Pasang Top Plate</p>
            <div className="opr_row opr_row_2">
              <Field label="Kepala Shift" required className="opr_span_2">
                <select
                  className="opr_select"
                  value={kepalaShift}
                  onChange={(e) => setKepalaShift(e.target.value)}
                >
                  <KepalaShiftOptions />
                </select>
              </Field>

              <Field label="Pilih Produk" required className="opr_span_2">
                <Select
                  placeholder={pasangStikerSelect || "Pilih Produk"}
                  value={pasangStikerSelect || ""}
                  options={[
                    {
                      value: "TOP COVER GTZ5S (No.13)",
                      label: "TOP COVER GTZ5S (No.13)",
                    },
                    {
                      value: "TOP COVER GTZ5S (No.15)",
                      label: "TOP COVER GTZ5S (No.15)",
                    },
                  ]}
                  onChange={(e) => setPasangStikerSelect(e)}
                />
              </Field>

              <Field label="Jumlah (Pcs)" required>
                <NumInput
                  placeholder="Jumlah (Pcs)"
                  value={jumlahPasangKaret}
                  onChange={(e) =>
                    setJumlahPasangKaret(e.target.value.split(".").join(""))
                  }
                />
              </Field>
              <Field label="Downtime (Menit)">
                <NumInput
                  placeholder="Downtime"
                  value={downtimePasangKaret}
                  onChange={(e) =>
                    setDowntimePasangKaret(e.target.value.split(".").join(""))
                  }
                />
              </Field>
            </div>
          </div>

          <div className="opr_card">
            <p className="opr_card_title">Keterangan Pasang Top Plate</p>
            <textarea
              className="opr_textarea"
              value={keteranganPasangKaret}
              onChange={(e) => setKeteranganPasangKaret(e.target.value)}
            />
          </div>

          <div className="opr_actions">
            <button
              className="button_submit_memo"
              onClick={() => handleKirimPasangTopPlate()}
            >
              Kirim
            </button>
          </div>
        </>
      ) : (
        ""
      )}
    </div>
  );
};
export default Operator;
